import axios from 'axios';

const OrganisationService = {
  addOrganisation(json) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/AddOrganisation`;
    return axios.post(url, json);
  },

  updateOrganisation(ID, json) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/${ID}`;
    return axios.put(url, json);
  },

  deleteOrganisation(Id) {
    const url = `${process.env.REACT_APP_HOST_URL}organisation/${Id}`;
    return axios.delete(url);
  },

  getOrganisations(parameters) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation`;
    return axios.get(url);
  },

  getOrganisation(ID) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/${ID}`;
    return axios.get(url);
  },

  exportOrganisations(parameters) {
    const url = `${process.env.REACT_APP_HOST_URL}Organisation/export${parameters}`;
    return axios.get(url, { responseType: 'arraybuffer' });
  },

  // Endpoint for switching user organisation
  switchOrganisation(json) {
    const url = `${process.env.REACT_APP_HOST_URL}User/ChangeUserActiveOrganisation`;
    return axios.post(url, json);
  },
};

// const organisationService = new OrganisationService();
export default OrganisationService;
